/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg12x7%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1rpy%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rjcu2gc%7Bpadding-block%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8i4vh%7Bfont%3Avar(--ds-font-heading-xxsmall%2Cnormal%20653%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
import { type ReactNode } from 'react';
import { useMenuSectionContext } from './menu-section-context';
const styles = {
  root: "_11c8i4vh _1rjcu2gc _syaz1rpy _bozg12x7"
};

/**
 * __MenuSectionHeading__
 *
 * The label for the menu section group.
 */
export const MenuSectionHeading = ({
  children,
  headingLevel
}: {
  /**
   * The text of the heading.
   */
  children: ReactNode;
  /**
   * Renders the label as a semantic heading (`<h1>`–`<h6>`) at the given level.
   * When omitted, the label renders as a non-heading paragraph (default).
   */
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
}): JSX.Element => {
  const id = useMenuSectionContext();
  const HeadingTag = headingLevel ? (`h${headingLevel}` as const) : 'p';
  return <HeadingTag id={`${id}-heading`} className={ax([styles.root])}>
			{children}
		</HeadingTag>;
};